import { logout as logoutRequest } from "services/authService";

/**
 * End the session without navigating: notify the server, then drop all local
 * state. Other open tabs see the cleared storage and go to the sign-in page.
 *
 * Order matters — the API call needs the tokens, so it has to happen before
 * localStorage is cleared. It cannot reject (see services/authService), so a
 * failed call still ends the session locally.
 */
export async function endSession({ timeoutMs } = {}) {
  await logoutRequest({ timeoutMs });

  try {
    localStorage.clear();
  } catch (e) {
    // storage disabled — nothing was persisted
  }
}

/**
 * Sign the user out and return to the sign-in page.
 *
 * The server call is awaited rather than fired and forgotten, because
 * `window.location.href` can cancel an in-flight request.
 */
export default async function logoutAndRedirect() {
  await endSession();
  window.location.href = "/authentication/sign-in";
}
